// extracted by mini-css-extract-plugin
export default {"card":"OY-z","carouselContainer":"PY-z","carouselContent":"QY-z"};